import { t } from 'i18next';
import * as yup from 'yup';
import { AnyObjectSchema } from 'yup';

export const VenuePartnerLoginForm = (identificationNumber: any): AnyObjectSchema => {
  return yup.object().shape({
    email: yup
      .string()
      .required(t('tomorrow-login-identification-number-required', { identificationType: identificationNumber })),
    password: yup.string().required(t('tomorrow-login-password-required')),
  });
};
